import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard React components
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";
import VuiProgress from "components/VuiProgress";
import VuiInfoItemUser from "components/VuiInfoItemUser";
import VuiLoading from "components/VuiLoading";
import VuiLabel from "components/VuiLabel";

//
import breakpoints from "assets/theme/base/breakpoints";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";

import api from "services/api";
import colors from "assets/theme/base/colors";
import moment from "moment";

import Pagination from "../usePagination";
import SearchItem from "../SearchItem";

import useWindowDimensions from "hooks/useWindowDimensions";

const padLeft = (num, places) => String(num).padStart(places, "0");

const ButtonIconItem = ({ name = "person", fontSizeIcon = "32px", onClick }) => {
  return (
    <IconButton
      size="small"
      color="inherit"
      sx={navbarIconButton}
      variant="contained"
      onClick={onClick}
    >
      <Icon fontSize={fontSizeIcon}>{name}</Icon>
    </IconButton>
  );
};

const INFO_TABLE_GRID = 0;
const INFO_TABLE_LIST = 1;

function Units() {
  const [refreshInterval, setRefreshInterval] = useState(60000);
  const userLogged = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(null);
  const [toogleInfo, setToogleInfo] = useState(INFO_TABLE_GRID);
  const [isMobile, setIsMobile] = useState(false);

  const [rowsInit, setRowsInit] = useState([]);
  const [pages, setPages] = useState(1);
  const [limit, setLimit] = useState(30);

  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [isGroupAdmin, setIsGroupAdmin] = useState(0);

  const [countAllUser, setCountAllUser] = useState(0);
  const [filterActive, setFilterActive] = useState(false);

  async function loadUsers() {
    // const res = await api.get(`users`);
    const res = await api.get(`users?page=${pages}&limit=${limit}&orderby=name,initials`);
    // console.log(
    //   ">>> DashUsers:userLogged",
    //   res.data.data[0]?.countAllRegister,
    //   userLogged,
    //   res.data.data
    // );

    const data = res.data.data;

    data.sort((a, b) => a.name > b.name);

    setRows(data);
    setRowsInit(data);
    setCountAllUser(res.data.data[0]?.countAllRegister);
    setLoading(false);
  }

  useEffect(() => {
    setIsGroupAdmin(userLogged.id_group === 1);
    loadUsers();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadUsers, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setIsMobile(true);
        setMobileNavbar(false);
      } else {
        setIsMobile(false);
        setMobileNavbar(false);
      }
    }

    /** 
     The event listener that's calling the displayMobileNavbar function when 
     resizing the window.
    */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  return (
    <Card
      sx={{
        height: "100% !important",
      }}
    >
      <VuiBox
        sx={{
          "& th": {
            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
              `${borderWidth[1]} solid ${grey[700]}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
          },
        }}
      >
        {loading ? (
          <VuiLoading />
        ) : (
          <VuiBox>
            <div
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                fontSize: 24,
                marginBottom: 20,
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                <VuiLabel
                  title={`Total de ${countAllUser} usuários`}
                  sizeTitle={"24px"}
                  colorTitle="warning"
                />
              </div>

              <VuiProgress value={0} color="white" label={false} />

              {isMobile ? null : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "white",
                    marginTop: 10,
                  }}
                >
                  {toogleInfo === INFO_TABLE_GRID ? (
                    <>
                      <SearchItem
                        onClick={async (text, filter) => {
                          const filterRows = rows.filter((x) =>
                            x["name"].toLowerCase().includes(text)
                          );

                          setFilterActive(true);

                          if (filterRows.length === 0) {
                            const res = await api.get(`users?search=${text}&field=${filter}`);
                            setRows(res.data.data.sort((a, b) => a.name - b.name));
                          } else {
                            setRows(filterRows);
                          }
                        }}
                        onReset={() => {
                          setRows(rowsInit);
                          setFilterActive(false);
                        }}
                      />

                      {!filterActive ? (
                        <Pagination
                          currentPage={pages}
                          totalPages={Math.round(countAllUser / limit)}
                          onChange={async (page) => {
                            if (page > 0 && page <= Math.round(countAllUser / limit)) {
                              // setLoading(true);
                              console.log(
                                `>>> Pagination:api.get:users?page=${page}&limit=${limit}`
                              );
                              const res = await api.get(`users?page=${page}&limit=${limit}`);
                              console.log(">>> res:", res.data.data);
                              setCountAllUser(res.data.data[0]?.countAllRegister);
                              setRows(res.data.data);
                              setPages(page);
                            }
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <div>
                      <div></div>
                    </div>
                  )}

                  <VuiTypography
                    variant="lg"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    color="white"
                    p={"10px"}
                  >
                    <ButtonIconItem
                      name="grid_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_GRID);
                      }}
                    />

                    <div style={{ width: 5 }} />

                    <ButtonIconItem
                      name="list_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_LIST);
                      }}
                    />
                  </VuiTypography>
                </div>
              )}
            </div>

            {toogleInfo === INFO_TABLE_GRID ? (
              <Box sx={{ flexGrow: 2 }}>
                <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 6, md: 12 }}>
                  {rows.map((item, index) => {
                    return (
                      <Grid item xs={12} sm={12} md={3} key={index}>
                        <VuiInfoItemUser item={item} isGroupAdmin={isGroupAdmin} />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            ) : null}
          </VuiBox>
        )}
      </VuiBox>
    </Card>
  );
}

export default Units;
